export const watchJackpotsV2 = {
  initial: 'init',
  states: {
    init: {
      on: {
        GET_RECENTLY_PLAYED_JACKPOTSV2: {
          target: 'getRecentlyPlayedJackpotsV2',
        },
        GET_JACKPOTSV2: {
          target: 'getJackpotsV2',
        },
        REFETCH_STALE_JACKPOTSV2: {
          target: 'refetchStaleJackpotsV2',
        },
        GET_SEARCH_GAMES_JACKPOTVS2: {
          target: 'getJackpotsV2ForSearchGames',
        },
      },
    },
    getJackpotsV2: {
      invoke: {
        src: 'getJackpotsV2',
        onDone: {
          actions: ['updateJackpotsV2', 'categories_reload'],
          target: 'init',
        },
      },
    },
    getRecentlyPlayedJackpotsV2: {
      invoke: {
        src: 'getRecentlyPlayedJackpotsV2',
        onDone: [
          {
            target: 'init',
            actions: ['updateJackpotsV2', 'rp_rerender'],
          },
        ],
      },
    },
    refetchStaleJackpotsV2: {
      invoke: {
        src: 'refetchStaleJackpots',
        onDone: [
          // TODO: add logic to check whether the jackpots data for game tiles has changed GT-2550
          {
            actions: ['updateJackpotsV2', 'categories_reload'],
            target: 'init',
            cond: 'isJackpotsDataUpdated',
          },
          { target: 'init' },
        ],
      },
    },
    getJackpotsV2ForSearchGames: {
      invoke: {
        src: 'getJackpotsV2ForSearchGames',
        onDone: {
          actions: ['updateJackpotsV2', 'search_items_reload'],
          target: 'init',
        },
      },
    },
  },
};
